import React from "react";
import SupportFAQ from "../Models/SupportFAQ";

interface Props {
  showCategoryNames: boolean;
  questionList: readonly SupportFAQ[];
  onClick: (id: number) => void;
  selectedQuestion: number | undefined;
}
function QuestionAnswerDetails({
  showCategoryNames,
  questionList,
  onClick,
  selectedQuestion,
}: Props) {
  const openedToggleCharacter = "\uE80C";
  const closedToggleCharacter = "\uE801";

  const isOpen = (id: number) => {
    return selectedQuestion && id === selectedQuestion;
  };

  return (
    <>
      {questionList.map((faq, index) => {
        return (
          <div
            key={faq.id}
            className={`support-qa${isOpen(faq.id) ? " qa-open" : ""}`}
          >
            <button
              className="bg-transparent border-none pl-0 text-left w-full text-black"
              type="button"
              onClick={() => onClick(faq.id)}
              aria-expanded={selectedQuestion === faq.id}
            >
              <span
                className={`question${
                  index === 0 && !showCategoryNames ? " border-t-0" : ""
                }`}
              >
                {faq.question}
                <span className="toggleswitch" aria-hidden="true">
                  {isOpen(faq.id)
                    ? openedToggleCharacter
                    : closedToggleCharacter}
                </span>
              </span>
            </button>
            <span className="answer">
              <div dangerouslySetInnerHTML={{ __html: faq.answer }} />
            </span>
          </div>
        );
      })}
    </>
  );
}

export default QuestionAnswerDetails;
